"use client";

import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useMe } from "@/hooks/api/useMe";

export function RequireAdmin({ children }: { children: ReactElement }) {
  const { user } = useAuth();
  const { isLoading } = useMe();

  // Wait for /api/auth/me to hydrate user role before deciding.
  if (!user && isLoading) {
    return <div className="p-6 text-sm text-muted-foreground">Checking permissions…</div>;
  }

  if (user?.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
